<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPageBtn">
        常见问题
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 资产 -->
    <div class="labourParticulars-box labourParticulars-active">
        <div class="boxsha" v-for="(item,i) in data3" :key="i">
            <p class="classp">{{item.name}}</p>
            <span class="calssSpan" @click="addGetBtn2(i)">了解更多</span>
        </div>
    </div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false,
            agreementShow1: false,
            // 资产
            data3: [{
                    name: "“想申请办公用品，采买范围有限制吗？”"
                },
                {
                    name: "“10万元以上的物质，需要提前多久申请采购？”"
                }
            ],
        };
    },
    methods: {
        getOnPage() {
            var code = this.$route.params.code
            if (code == 'd') {
                this.$router.push({
                    name: 'Search',
                    params: {
                        code: "q"
                    }
                })
            } else if (code == 'c') {
                this.$router.push({
                    name: 'Search',
                    params: {
                        code: "c"
                    }
                })
            } else if (code == 'a') {
                this.$router.push({
                    name: 'Search',
                    params: {
                        code: "a"
                    }
                })
            }
            this.$router.push({
                name: 'Search',
                params: {
                    code: "123321"
                }
            })
        },
        getOnPageBtn() {
            this.$router.push({
                name: "AssetHome"
            })
        },
        addGetBtn2(i) {
            if (i == 0) {
                this.$router.push({
                    name: "AssetFlow3",
                    params: {
                        name: "as"
                    }
                })
            } else if (i == 1) {
                this.$router.push({
                    name: "AssetFlow4",
                    params: {
                        code: "13",
                        name: "sd"
                    }
                })
            }
        },
    },
    mounted() {
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical", // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style scoped>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars-box {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars-box .calssSpan {
    color: #FA6400;
    display: block;
}

.labourParticulars-active {
    padding-top: 0 !important;
}

.labourParticulars-box .boxsha {
    width: 90%;
    height: 12%;
    padding: 10px 3% 10px 7%;
    float: left;
    border-bottom: 1px solid #EDEDED;
}

.labourParticulars-box .classp {
    width: 100%;
    height: 50px;
    color: #838383
}

.labourParticulars-box .calssSpan {
    width: 21%;
    float: right;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    display: block;
    margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ/issueManpower2.vue